/* src/app/shared/components/credit-card-pagination-renderer/credit-card-pagination-renderer.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
:host {
  display: block;
  width: 100%;
}
.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 32px;
  width: 100%;
  padding: 16px 8px;
  background: var(--cds-background-main);
  border-top: 1px solid var(--cds-border);
}
.pagination-size {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}
.pagination-select {
  display: inline-block;
  min-width: 110px;
  max-width: 110px;
}
.pagination-label,
.pagination-range,
.pagination-page {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: 400;
  color: --cds-text-medium;
  line-height: 1;
  white-space: nowrap;
  font-feature-settings: "ss01" 1;
}
.pagination-page strong {
  font-weight: 600;
}
.pagination-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
.pagination-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.pagination-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: none;
  border-radius: 4px;
  cursor: pointer;
  color: var(--cds-highlight-5, #005ca9);
  font-size: 16px;
}
.pagination-arrow:disabled {
  color: var(--cds-text-light, #9eb2b8);
  cursor: default;
}
/*# sourceMappingURL=credit-card-pagination-renderer.component.css.map */
